module.exports = __webpack_public_path__ + "img/amway-logo-black.3dfb444a.svg";